<template>
    <v-icon
        v-text="icons.mdiPencilOffOutline"
        :class="{'grey--text lighten-1': isDark, 'grey--text darken-1': !isDark}"
        class="mx-1"
        x-small
    ></v-icon>
</template>
<script>
import MixinIcon from "@/mixins/MixinIcon";
import MixinDark from "@/mixins/database/MixinDark";

export default {
    name: 'IconsUpdatable',
    mixins: [MixinIcon, MixinDark],

}
</script>
